// extracted by mini-css-extract-plugin
export default {"loadingBarWrapper":"LoadBoundary_loadingBarWrapper__bdHhF","loadingBar":"LoadBoundary_loadingBar__0355d"};